import moment from "moment";
import { Race } from "src/models/race.model";
import { Meeting } from "src/models/saloon-models/meeting.model";


export function formatTime(raceTime: string) {
  let today = moment();
  return today.diff(moment(raceTime), 'minutes');
}

export function resolveRaceDate(racedt: string, raceStart?: string): string {
  return raceStart ? moment.utc(raceStart).local().format() : racedt;
}

export function getDateTime(raceTime: string, lang: string){
  if(raceTime.length){
    return moment(raceTime).locale(lang).format('LT')
  }

  return ''
}

export function earliestIndex(races: Race[]): number {
  let bestPastIdx = -1;
  let bestPastLeft = -Infinity; // want the largest left ≤ 0
  let bestFutureIdx = -1;
  let bestFutureLeft = Infinity; // want the smallest left > 0

  for (let i = 0; i < races.length; i++) {
    const left = Number(formatTime(races[i].date));
    if (!Number.isFinite(left)) continue;

    if (left <= 0 && (left > bestPastLeft)) {
        bestPastLeft = left;
        bestPastIdx = i;

    } else if (left < bestFutureLeft) {
        bestFutureLeft = left;

        bestFutureIdx = i;
      }
    }

  return bestPastIdx !== -1 ? bestPastIdx : bestFutureIdx;
}

export function isSameCalendarDay(a: string, b: string): boolean {
  let dateA = moment(a);
  let dateB = moment(b);
  return dateA.isSame(dateB, 'day'); // compares by local calendar day
}

export function isRaceFinished(race: Race): boolean {
  const arrivalData = race && race.arrivee ? race.arrivee.split('-') : [];
  const hasRapport = arrivalData.length > 0 && arrivalData[0] !== '';
  return hasRapport || (formatTime(race.date) >= 0 && race.status !== '0');
}

// Bettable races first; earliest time first within each group.
export function compareRacesByBetEligibility(a: Race, b: Race): number {
  const aFinished = isRaceFinished(a) ? 1 : 0;
  const bFinished = isRaceFinished(b) ? 1 : 0;
  return aFinished !== bFinished ? aFinished - bFinished : new Date(a.date).getTime() - new Date(b.date).getTime();
}

// A meeting's rank is its best (bettable, then earliest) race — same rule, one level up.
export function compareMeetingsByBetEligibility(a: Meeting, b: Meeting): number {
  const aBest = [...(a.races ?? [])].sort(compareRacesByBetEligibility)[0];
  const bBest = [...(b.races ?? [])].sort(compareRacesByBetEligibility)[0];
  if (!aBest || !bBest) return (aBest ? 0 : 1) - (bBest ? 0 : 1);
  return compareRacesByBetEligibility(aBest, bBest);
}
